import { create } from "zustand";

const useEquatorialWidgetsDataStore = create(set => ({
  equatorialWidgetsData: {},
  setEquatorialWidgetsData: equatorialWidgetsData =>
    set({ equatorialWidgetsData })
}));

export default useEquatorialWidgetsDataStore;
